import { defineStore } from 'pinia'

export const useAuthStore = defineStore('auth', {
    state: () => ({
        token: null,
        user: null,
        cart: {}
    }),

    actions: {
        setToken (token) {
            this.token = token
        },
        setUser (user) {
            this.user = user
        },
        setCart (cart) {
            this.cart = cart
        },
        addCart (cart) {
            this.cart.productsCart.push(cart)
        },
        deleteCart (index) {
            this.cart.productsCart.splice(index)
        },
        logout () {
            this.token = null
            this.user = null
            this.cart = {}
        }
    },

    getters: {
        getToken () {
            return this.token
        },
        getUser () {
            return this.user
        },
        isConnected () {
            return this.token !== null && this.user !== null
        },
        isAdmin () {
            return this.user ? this.user.isAdmin : false
        },
        getCart () {
            return this.cart
        },
        getNumberOfArticles () {
            return this.cart?.productsCart ? this.cart?.productsCart?.length : 0
        }
    }
})
